import { Result } from 'antd';

const NotFound = ({subText}) => {

  return (
   <Result
      status="404"
      title="404"
      subTitle={subText}
    />
  )
}

export default NotFound
